<template>
  <v-dialog v-model="timerFormModal" persistent max-width="600">
    <template v-slot:activator="{on, attrs}">
      <v-btn
        fab
        color="#2722a6"
        variant="success"
        v-on="on"
        v-bind="attrs"
        class="p-3"
        :disabled="disabled"
        :title="
          disabled
            ? 'Use the new time & tasks app to add timer entries'
            : 'Add timer entry'
        "
      >
        <v-icon large color="white">mdi-plus</v-icon>
      </v-btn>
    </template>
    <create-timer-form
      v-if="timerFormModal"
      :key="formKey"
      :date="formDate"
      @click-to-close="closeCreateTimerFormDialog"
    />
  </v-dialog>
</template>
<script>
import CreateTimerForm from "./CreateTimerForm";

export default {
  name: "CreateTimerModal",
  props: {
    formDate: {},
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      timerFormModal: false,
      formKey: 0,
    };
  },
  components: {
    CreateTimerForm,
  },
  methods: {
    closeCreateTimerFormDialog() {
      this.timerFormModal = false;
    },
  },
  watch: {
    timerFormModal(isOpen) {
      if (isOpen) {
        this.formKey += 1;
      }
    },
  },
};
</script>
